module.exports = __webpack_public_path__ + "img/slika59.6f74f109.jpg";